import { ReactQueryCacheTime, ReactQueryStaleTime } from '@openx/constants/react-query.ts';
import { getHttpFromQueryFnContext } from '@openx/utils/api/getHttpFromQueryMeta.ts';
import { QueryKeys } from '@openx/utils/api/queryKeys.ts';
import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { DealLibraryItem } from '../../types/index.ts';

export type DealTemplateJson = {
  deal_templates: DealLibraryItem[];
  popular_tags: string[];
};

const dealLibraryList = (context: QueryFunctionContext) => {
  const http = getHttpFromQueryFnContext(context);
  return http.get('/deal-library').json<DealTemplateJson>();
};

export const useDealLibraryListFetch = () => {
  const { data, isLoading, isError } = useQuery({
    gcTime: ReactQueryCacheTime.MINUTES_90,
    queryFn: dealLibraryList,
    queryKey: [QueryKeys.DEAL_LIBRARY],
    staleTime: ReactQueryStaleTime.MINUTES_60,
  });

  const dealTemplates = data?.deal_templates || [];
  const updatedDealTemplates = dealTemplates.map(template => ({
    ...template,
    account_uid: 'deal-library-account-uid',
  }));

  return {
    dealTemplates: updatedDealTemplates,
    isError,
    isLoading,
    popularTags: data?.popular_tags ?? [],
  };
};
